module.exports = __webpack_public_path__ + "static/project-8c-2942a842bc65d1771a4f2d1deb4b0dc0.png";